import { useCallback, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { BranchVersion } from "~/entities/branch-version/types";
import { SelectedVersionContext } from "~/features/branch-version/hooks/use-selected-version";
import {
  clearLegacySelectedVersion,
  writeVersionIdForBranch,
} from "~/features/branch-version/lib/selected-version-storage";
import { checkIsLoggedIn } from "~/shared/lib/auth";

const LAST_PATH_KEY = "mst:lastPath";

export function AuthGuard() {
  const location = useLocation();
  const isLoggedIn = checkIsLoggedIn();

  // 로그인 직후 redirectAfterLogin 정리
  useEffect(() => {
    if (isLoggedIn) {
      localStorage.removeItem("redirectAfterLogin");
    }
  }, [isLoggedIn]);

  // 현재 경로를 localStorage에 저장 (로그인 후 복원용)
  useEffect(() => {
    if (isLoggedIn && location.pathname !== "/") {
      localStorage.setItem(LAST_PATH_KEY, location.pathname + location.search);
    }
  }, [isLoggedIn, location.pathname, location.search]);

  // 레거시 단일 key 정리 (per-branch map 으로 이관됨)
  useEffect(() => {
    clearLegacySelectedVersion();
  }, []);

  const [selectedVersion, setSelectedVersionState] = useState<BranchVersion | undefined>(undefined);

  const setSelectedVersion = useCallback((version: BranchVersion | undefined) => {
    setSelectedVersionState(version);
    if (version) {
      writeVersionIdForBranch(version.branchUid, version.id);
    }
  }, []);

  if (!isLoggedIn) {
    return <Navigate to={`/login${location.search}`} state={{ from: location.pathname }} replace />;
  }

  return (
    <SelectedVersionContext.Provider value={{ selectedVersion, setSelectedVersion }}>
      <Outlet />
    </SelectedVersionContext.Provider>
  );
}
